import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

/**
 * Draft a create/update from free text. Does not save.
 * @param {string} text
 * @param {{ itemId?: string|null, title?: string }|null} [focus]
 * @returns {Promise<object>}
 */
export async function interpretScheduleChat(text, focus = null) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error("Bitte melde dich an.");
  const res = await fetch(`${API_BASE}/api/chat/schedule`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      text,
      ...(focus?.title ? { focus: { itemId: focus.itemId || null, title: focus.title } } : {}),
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Antwort fehlgeschlagen (${res.status}).`);
  }
  return data;
}
